import {
    STUDIO_EDIT_TOPICS_LIST_REQUEST,
    STUDIO_EDIT_TOPICS_LIST_RESPONSE,
    STUDIO_EDIT_TOPICS_LIST_COUNT_REQUEST,
    STUDIO_EDIT_TOPICS_LIST_COUNT_RESPONSE,
    STUDIO_EDIT_DIMENSIONS_LIST_REQUEST,
    STUDIO_EDIT_DIMENSIONS_LIST_RESPONSE,
    STUDIO_EDIT_DIMENSIONS_LIST_COUNT_REQUEST,
    STUDIO_EDIT_DIMENSIONS_LIST_COUNT_RESPONSE,
    STUDIO_EDIT_RELATED_DIMENSIONS_LIST_REQUEST,
    STUDIO_EDIT_RELATED_DIMENSIONS_LIST_RESPONSE,
    STUDIO_EDIT_DESELECT_TOPIC,
    STUDIO_EDIT_ADD_KEY_ISSUES_REQUEST,
    STUDIO_EDIT_ADD_KEY_ISSUES_RESPONSE,
    STUDIO_EDIT_KEY_ISSUE_DRAG_START,
    STUDIO_EDIT_KEY_ISSUE_DRAG_END,
    STUDIO_EDIT_SELECT_TAB,
    STUDIO_EDIT_TOPIC_DIMENSION_SEARCH,
    STUDIO_EDIT_TOGGLE_IMAGE_UPLOAD_MODAL,
    UNAUTHENTICATED
} from "../../actions/action-types"
import { serialiseSearchCriteria } from "../paging/paging-reducer-utils"

const defaultState = {
    editModeTab: "topic",
    editSearchTerm: "",
    editSelectedTopicId: null,
    editSelectedTopicDimensionsSearchCriteria: "",
    isDraggingKeyIssue: false,
    isFetchingEditDimensionsToAdd: {},
    isFetchingEditSelectedTopic: false,
    editDimensionSearchCriteria: "search=",
    isFetchingEditDimensionList: false,
    isFetchingEditDimensionListCount: false,
    editTopicSearchCriteria: "name=",
    isFetchingEditTopicList: false,
    isFetchingEditTopicListCount: false,
    isImageUploadModalOpen: false
}

export default (state = defaultState, action) => {
    const {
        type,
        searchCriteria,
        dimensionIds,
        topicId,
        dimensionActions
    } = action
    switch (type) {
        case STUDIO_EDIT_KEY_ISSUE_DRAG_START:
            return {
                ...state,
                isDraggingKeyIssue: true
            }
        case STUDIO_EDIT_KEY_ISSUE_DRAG_END:
            return {
                ...state,
                isDraggingKeyIssue: false
            }
        case STUDIO_EDIT_ADD_KEY_ISSUES_REQUEST: {
            const newIsFetchingStates = dimensionIds.reduce((states, id) => {
                states[id] = true
                return states
            }, {})
            if (topicId) newIsFetchingStates[topicId] = true
            return {
                ...state,
                isFetchingEditDimensionsToAdd: {
                    ...state.isFetchingEditDimensionsToAdd,
                    ...newIsFetchingStates
                }
            }
        }
        case STUDIO_EDIT_ADD_KEY_ISSUES_RESPONSE: {
            const newIsFetchingStates = dimensionActions.reduce(
                (states, { data }) => {
                    states[data.id] = false
                    return states
                },
                {}
            )
            if (topicId) newIsFetchingStates[topicId] = false
            return {
                ...state,
                isFetchingEditDimensionsToAdd: {
                    ...state.isFetchingEditDimensionsToAdd,
                    ...newIsFetchingStates
                }
            }
        }
        case STUDIO_EDIT_DESELECT_TOPIC:
            return {
                ...state,
                editSelectedTopicId: null,
                editSelectedTopicDimensionsSearchCriteria: ""
            }
        case STUDIO_EDIT_RELATED_DIMENSIONS_LIST_REQUEST:
            return {
                ...state,
                editSelectedTopicId: topicId,
                editSelectedTopicDimensionsSearchCriteria: `statuses=Active&topics=${topicId}`,
                isFetchingEditSelectedTopic: true
            }
        case STUDIO_EDIT_RELATED_DIMENSIONS_LIST_RESPONSE:
            return {
                ...state,
                isFetchingEditSelectedTopic: false
            }
        case STUDIO_EDIT_TOPIC_DIMENSION_SEARCH:
            return {
                ...state,
                editSearchTerm: action.searchTerm
            }
        case STUDIO_EDIT_TOPICS_LIST_REQUEST:
            return {
                ...state,
                editTopicSearchCriteria: serialiseSearchCriteria(
                    searchCriteria
                ),
                isFetchingEditTopicList: true
            }
        case STUDIO_EDIT_TOPICS_LIST_RESPONSE:
            return {
                ...state,
                isFetchingEditTopicList: false
            }
        case STUDIO_EDIT_TOPICS_LIST_COUNT_REQUEST:
            return {
                ...state,
                editTopicSearchCriteria: serialiseSearchCriteria(
                    searchCriteria
                ),
                isFetchingEditTopicListCount: true
            }
        case STUDIO_EDIT_TOPICS_LIST_COUNT_RESPONSE:
            return {
                ...state,
                isFetchingEditTopicListCount: false
            }
        case STUDIO_EDIT_DIMENSIONS_LIST_REQUEST:
            return {
                ...state,
                editDimensionSearchCriteria: serialiseSearchCriteria(
                    searchCriteria
                ),
                isFetchingEditDimensionList: true
            }
        case STUDIO_EDIT_DIMENSIONS_LIST_RESPONSE:
            return {
                ...state,
                isFetchingEditDimensionList: false
            }
        case STUDIO_EDIT_DIMENSIONS_LIST_COUNT_REQUEST:
            return {
                ...state,
                editDimensionSearchCriteria: serialiseSearchCriteria(
                    searchCriteria
                ),
                isFetchingEditDimensionListCount: true
            }
        case STUDIO_EDIT_DIMENSIONS_LIST_COUNT_RESPONSE:
            return {
                ...state,
                isFetchingEditDimensionListCount: false
            }
        case STUDIO_EDIT_SELECT_TAB:
            return {
                ...state,
                editModeTab: action.tab
            }
        case STUDIO_EDIT_TOGGLE_IMAGE_UPLOAD_MODAL:
            return {
                ...state,
                isImageUploadModalOpen: !state.isImageUploadModalOpen
            }
        case UNAUTHENTICATED:
            return defaultState
        default:
            return state
    }
}
